import { useEffect, useMemo } from 'react';
import { UnsavedChangesContext } from './types';
import { useContextSelector } from 'use-context-selector';
import { FieldValues, UseFormReturn } from 'react-hook-form';

export function useRegisterUnsavedChanges<T extends FieldValues>(
  settingsKey: string,
  form: UseFormReturn<T>,
  isDirty?: boolean,
): boolean {
  const isUnsavedChanges = useMemo(() => {
    return Object.keys(form.formState.dirtyFields).length > 0 || !!isDirty;
  }, [Object.keys(form.formState.dirtyFields).length, isDirty]);
  const setUnsavedChanges = useContextSelector(
    UnsavedChangesContext,
    (v) => v.setUnsavedChanges,
  );
  useEffect(() => {
    setUnsavedChanges(settingsKey, isUnsavedChanges);
  }, [isUnsavedChanges]);

  return isUnsavedChanges;
}
